import React, { Component } from 'react'

export default class Skills extends Component {
  render() {
    return (
      <div><section class="colorlib-skills" data-section="skills">
      <div class="colorlib-narrow-content">
          <div class="row">
              <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                  <span class="heading-meta">My Specialty</span>
                  <h2 class="colorlib-heading animate-box">My Skills</h2>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Programming Languagues</p>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInLeft">
                  <div class="progress-wrap">
                      <h3>Python</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Java</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInLeft">
                  <div class="progress-wrap">
                      <h3>SQL</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"75%"}}>
                          <span>75%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Unix Shell Scripting</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>


              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Web Development</p>
              </div>
             
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>React JS</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
                
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Angular</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>NodeJS</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>     
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>JavaScript</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
          
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>TypeScript</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Express JS</h3>
                      <div class="progress">
                           <div class="progress-bar color-6" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Sequelize ORM</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>HTML5</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"90%"}}>
                          <span>90%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>CSS3</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"90%"}}>
                          <span>90%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>SASS</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
             
               <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>XML</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
               <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>JSON</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"90%"}}>
                          <span>90%</span>
                            </div>
                      </div>
                  </div>
              </div>
               <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Django</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
               <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Spring MVC</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>

                 <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Hibernate</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
                 <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>JSP</h3>
                      <div class="progress">
                           <div class="progress-bar color-6" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"75%"}}>
                          <span>75%</span>
                            </div>
                      </div>
                  </div>
              </div>
                 <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>JQuery</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
                 <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Ajax</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>



              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Database Management System</p>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>MySQL</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>MongoDB</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div> 
             <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Oracle</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>   

              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Cloud Technologies and CI/CD Techniques</p>
              </div>


              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Amazon Web Services</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Google Cloud Platform</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="60"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"60%"}}>
                          <span>60%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>CircleCI</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Terraform</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Github Actions</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>


              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Version Control Systems</p>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Git</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Bitbucket</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"75%"}}>
                          <span>75%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Apache SVN</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="65"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"65%"}}>
                          <span>65%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <p>Software/Tools</p>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Apache Hadoop</h3>
                      <div class="progress">
                           <div class="progress-bar color-4" role="progressbar" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}>
                          <span>85%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Apache Spark</h3>
                      <div class="progress">
                           <div class="progress-bar color-6" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Visual Studio Code</h3>
                      <div class="progress">
                           <div class="progress-bar color-5" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>IntelliJ IDEA</h3>
                      <div class="progress">
                           <div class="progress-bar color-1" role="progressbar" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"80%"}}>
                          <span>80%</span>
                            </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>PyCharm</h3>
                      <div class="progress">
                           <div class="progress-bar color-2" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"70%"}}>
                          <span>70%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Jupyter</h3>
                      <div class="progress">
                           <div class="progress-bar color-3" role="progressbar" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"75%"}}>
                          <span>75%</span>
                            </div>
                      </div>
                  </div>
              </div>

              <div class="col-md-6 animate-box" data-animate-effect="fadeInRight">
                  <div class="progress-wrap">
                      <h3>Apache Netbeans</h3>
                      <div class="progress">
                           <div class="progress-bar color-7" role="progressbar" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100" style={{width:"90%"}}>
                          <span>90%</span>
                            </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>
  </section></div>


      )
    }
  }